import React from 'react';
import ReactExport from 'react-data-export';
import IconConvertToExcel from '../../../assets/images/IconConvertToExcel.png';
import { IconButton, Tooltip } from '@material-ui/core';
import { storageMonedaSigno } from '../../../assets/shared/sessionData';
import { formatNumber, formatTwoIntegerDigits } from '../../../assets/shared/formatNumber';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const TablaCuboToExcel = (props) => {
  const headersStyle = {
    font: { sz: '12', bold: true },
    fill: { fgColor: { rgb: 'FFD3D3D3' } },
    alignment: { horizontal: 'center' }
  };

  const cellsStyleVerifNegative = (value, isTotal) => {
    return {
      font: { sz: '10', bold: false, color: { rgb: value < 0 && 'FFFF0000' } },
      alignment: { horizontal: 'right' },
      fill: isTotal && { fgColor: { rgb: 'FFD3D3D3' } }
    };
  };

  const formatData = () => {
    var formatData = [];
    props.datasPorAnio.map((dataPorAnio) => {
      return dataPorAnio.meses.map((mes, index) => {
        return formatData.push([
          {
            value: index === 0 ? dataPorAnio.anio : '',
            style: { font: { sz: '10' } }
          },
          {
            value: `${formatTwoIntegerDigits(mes.mes)}`,
            style: cellsStyleVerifNegative(mes.mes)
          },
          {
            value: `${storageMonedaSigno()} ${formatNumber(mes.monto)}`,
            style: cellsStyleVerifNegative(mes.monto)
          }
        ]);
      });
    });

    return formatData;
  };

  const multiDataSet = [
    {
      columns: [
        {
          title: 'Año',
          width: { wpx: 55 },
          style: {
            font: { sz: '12', bold: true },
            fill: { fgColor: { rgb: 'FFD3D3D3' } }
          }
        },
        { title: `Mes`, width: { wpx: 50 }, style: headersStyle },
        {
          title: props.montosDe,
          width: { wpx: 150 },
          style: headersStyle
        }
      ],
      data: formatData()
    }
  ];

  return (
    <ExcelFile
      filename={`Analisis de ${props.montosDe.toLowerCase()}`}
      element={
        <Tooltip title="Descargar en excel">
          <IconButton style={{ marginRight: '10px' }} size="small">
            <img alt="" src={IconConvertToExcel} height={'28px'} />
          </IconButton>
        </Tooltip>
      }
    >
      <ExcelSheet dataSet={multiDataSet} name={`${props.montosDe.toLowerCase()}`} />
    </ExcelFile>
  );
};

export default TablaCuboToExcel;
